import React from 'react';
import {
  fileInputMultipleSchema,
  fileInputMultipleUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import environment from 'platform/utilities/environment';

const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
const ACCEPTED_FILE_TYPES = '.pdf,.jpg,.jpeg,.png';

const SupportingDocumentsDescription = (
  <>
    <p>
      You’ll need to upload a copy of your exam results and a receipt
      correlating to the cost of your exam including any required fees. You’ll
      need to scan your documents onto the device you’re using to submit this
      application, such as your computer, tablet, or mobile phone. You can
      upload your document from there.
    </p>
    <p>Guidelines for uploading a file:</p>
    <ul>
      <li>You can upload a .pdf, .jpeg, or .png file</li>
      <li>Your file should be no larger than 25MB</li>
    </ul>
  </>
);

const uiSchema = {
  ...titleUI('Upload your supporting documents'),
  'ui:description': SupportingDocumentsDescription,
  supportingDocuments: fileInputMultipleUI({
    title: 'Upload your supporting documents',
    required: true,
    fileUploadUrl: `${environment.API_URL}/v0/claim_attachments`,
    accept: ACCEPTED_FILE_TYPES,
    maxFileSize: MAX_FILE_SIZE_BYTES,
    formNumber: '22-0810',
    disallowEncryptedPdfs: false,
  }),
};

const schema = {
  type: 'object',
  properties: {
    supportingDocuments: fileInputMultipleSchema(),
  },
};

export { schema, uiSchema };
